import apiClient from "@shared/config/axiosConfig";

/**
 * Servicio de API para tickets de soporte técnico (Trello)
 */
const supportTicketService = {
  /**
   * Crear un ticket de soporte técnico
   * @param {Object} ticketData
   * @param {string} ticketData.type - bug | suggestion | improvement | question
   * @param {string} ticketData.priority - alta | media | baja
   * @param {string} ticketData.title - Título del ticket
   * @param {string} ticketData.description - Descripción detallada
   * @param {string} [ticketData.module] - Módulo afectado
   * @param {string} [ticketData.steps] - Pasos para reproducir
   * @param {string} [ticketData.expected] - Comportamiento esperado
   * @param {string} [ticketData.jamUrl] - URL de grabación Jam
   */
  createTicket: (ticketData) => {
    return apiClient.post("/error-logs/support-ticket", ticketData);
  },

  /**
   * Verificar si Trello está configurado
   */
  getTrelloStatus: () => {
    return apiClient.get("/error-logs/trello/status");
  },

  /**
   * Obtener todas las tarjetas y listas del tablero Trello
   */
  getAllCards: () => {
    return apiClient.get("/error-logs/trello/cards");
  },

  /**
   * Mover una tarjeta a otra lista (cambiar estado)
   * @param {string} cardId - ID de la tarjeta
   * @param {string} listId - ID de la lista destino
   */
  moveCard: (cardId, listId) => {
    return apiClient.put(`/error-logs/trello/cards/${cardId}/move`, { listId });
  },

  /**
   * Actualizar una tarjeta (nombre, descripción, etc.)
   * @param {string} cardId - ID de la tarjeta
   * @param {Object} updates - Campos a actualizar
   */
  updateCard: (cardId, updates) => {
    return apiClient.put(`/error-logs/trello/cards/${cardId}`, updates);
  },

  /**
   * Eliminar (archivar) o borrar permanentemente una tarjeta
   * @param {string} cardId - ID de la tarjeta
   * @param {boolean} permanent - Si true, elimina permanentemente
   */
  deleteCard: (cardId, permanent = false) => {
    return apiClient.delete(
      `/error-logs/trello/cards/${cardId}${permanent ? "?permanent=true" : ""}`,
    );
  },
};

export default supportTicketService;
